import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['toggle', 'body', 'icon'];

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();

    const expanded = this.toggleTarget.getAttribute('aria-expanded') === 'true';
    const next = !expanded;

    this.toggleTarget.setAttribute('aria-expanded', next.toString());
    this.bodyTarget.classList.toggle('show', next);

    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle('fa-chevron-right', !next);
      this.iconTarget.classList.toggle('fa-chevron-down', next);
    }
  }

  stopPropagation(event) {
    event.stopPropagation();
  }
}
